import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './styles.css';

export class PhoneBanner extends Component {
    static displayName = PhoneBanner.name;

    /*
     * <div className="bg-info clearfix" style={{ padding: '.5rem' }}>
     * </div>
     * https://getbootstrap.com/docs/4.1/utilities/display
     * https://fontawesome.com/how-to-use/on-the-web/using-with/react
     * https://www.npmjs.com/package/@fortawesome/react-fontawesome
     * https://fontawesome.com/icons?d=gallery
     * <FontAwesomeIcon icon="phone-square" size="2x" rotation={90} flip="horizontal" />
     * <FontAwesomeIcon icon="phone-square" size="7x" flip="horizontal" />
     */

    render() {
        return (
            <div className='text-right text-white phoneBanner'>
                <span className='mr-2'><i><FontAwesomeIcon icon="phone-square" size="lg" rotation={90} flip="horizontal" /></i>604-276-2552</span>
                <span className='d-none d-md-inline' ><i><FontAwesomeIcon icon="map-marker-alt" size="lg" /></i>100-6260 Graybar Road. Richmond, BC V6W 1H6, Canada</span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PhoneBanner/index.js